import styles from '../../styles/pointsAndGamification.module.scss';

const ListItem = ({ date, points, activities }) => {
  console.log('activities', activities);
  return (
    <div className={styles.points__activity__body__top__inner__item}>
      <div className={styles.points__activity__body__top__inner__item__date}>
        {date}
        <p
          className={
            styles.points__activity__body__top__inner__item__date__text
          }
        >
          {points > 0 ? `+${points} poena` : `${points} poena`}
        </p>
      </div>
      <div>
        {activities && activities.length > 0 && (
          <ul className={styles.points__activity__body__top__inner__item__list}>
            {activities?.map((activity, index) => (
              <li key={index}>{activity?.label}</li>
            ))}
          </ul>
        )}
      </div>
      <div className={styles.points__activity__body__top__inner__item__points}>
        {points > 0 ? `+${points} poena` : `${points} poena`}
      </div>
    </div>
  );
};
export default ListItem;
